import { normalizeLocale } from './locales'

const hints = {
  'zh-CN': '已确认可见区间的累计平均净金币速率；识别等待时间不计入，背包不可见期间不统计。',
  'zh-TW': '已確認可見區間的累計平均淨楓幣速率；辨識等待時間不計入，背包不可見期間不統計。',
  en: 'Average net Mesos over confirmed visible intervals, timed from the source frames. OCR delays and hidden inventory periods are excluded.',
  ja: '確認済みの表示区間における平均メル純増率。元画像の時刻で計算し、認識待ち時間とインベントリ非表示期間は含みません。',
  ko: '확인된 표시 구간의 평균 순 메소 변화율입니다. 원본 화면 시각으로 계산하며 인식 대기 시간과 인벤토리 비표시 구간은 제외합니다.',
}

export function mesosRateHint(locale: string): string { return hints[normalizeLocale(locale)] }
